export function replace_from(text) {
  let ru = /^из\sкниги\s«/.test(text);
  let es = /^De\s+("|&quot|“|”)/.test(text);
  let es2 = /^Del\slibro\sdel\sApocalipsis/.test(text);
  let es3 = /^Los\sprimeros\stres\sversículos/.test(text);
  let it =
    /^da\s+("|La|Segui|Continuazione|Bibbia|Registrazione|Discorsi)/.test(text);
  let it2 = /^I\sprimi\sdue\sversetti/.test(text);
  let de = /^aus\s„/.test(text);
  let fr = /^Extrait\sde\s«/.test(text);
  let sw = /^kutoka\skwa/.test(text);
  // let sw2 = /^katika\s/.test(text)
  let mn = /^("|“)+Үг/.test(text);
  let jp = /^("|『)+(言|小羊)/.test(text);
  let zu = /^Khetha\s/.test(text);
  let el = /^από\sτο\sβιβλίο\s«/.test(text);
  let hi = /^"मेमने\s/.test(text);
  let hi2 = /^"वचन\sदेह\s/.test(text);
  // let tl = /^kutoka\s/.test(text)
  let en = /^from\sUtterances/.test(text);
  let en2 = /^According\sto\sG/.test(text); //  According to God's Fellowship
  let en3 = /^from\sThe\sWord\sAppears/.test(text); //  from The Word Appears in the Flesh
  let pt = /^de\sA/.test(text); //  According to God's Fellowship
  let pt2 = /^de\sSeguir\so\sC/.test(text); //  de Seguir o Cordeiro e cantar cânticos novos
  let kr = /^―\s≪/.test(text);

  if (
    hi ||
    hi2 ||
    ru ||
    es ||
    es2 ||
    es3 ||
    it ||
    it2 ||
    de ||
    fr ||
    sw ||
    mn ||
    jp ||
    zu ||
    el ||
    en ||
    en2 ||
    en3 ||
    pt ||
    pt2 ||
    kr
  ) {
    return true;
  } else {
    return false;
  }
}
